module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image02-e4af2c809227559dc6d230dfb1a72f8a.png";